import styled from 'styled-components';

const Container = styled.div`
  padding: 50px 20px;
  position: relative;
  overflow: hidden;
  ${({ theme, overflowBackground }) => {
    if (theme && overflowBackground) {
      return `background:  linear-gradient(180deg, ${
        theme === 'Dark' ? 'var(--darkest)' : 'var(--white)'
      } 0%, ${theme === 'Dark' ? 'var(--darkest)' : 'var(--white)'} 58%, rgba(255,255,255,1) 58%);
        
        @media (max-width: 575px) {
          background:  linear-gradient(180deg, ${
            theme === 'Dark' ? 'var(--darkest)' : 'var(--white)'
          } 0%, ${
        theme === 'Dark' ? 'var(--darkest)' : 'var(--white)'
      } 25%, rgba(255,255,255,1) 25%);
        }
        `;
    }
  }}

  .toggle--switch {
    height: 100px;
    margin: 0 auto;
    padding: 10px;
    position: relative;
    width: 100%;
    max-width: ${({ twoItemToggle }) => (twoItemToggle ? '500px' : '650px')};
  }

  .toggle-copy {
    width: 700px;
    max-width: 100%;
    text-align: center;
    margin: ${({ displayCopyAboveToggle }) =>
      displayCopyAboveToggle ? '0 auto 30px auto' : '50px auto 0 auto'};
    font-size: var(--font-size-p);
  }

  .toggle--content-container {
    position: relative;
  }

  .show {
    display: block;
  }

  .hide {
    position: absolute;
    top: -1000%;
    left: 0;
  }

  h2 {
    text-align: center;
    margin-bottom: 40;
  }

  h4 {
    text-align: center;
    margin: 40px 0 20px 0;
  }

  .dropdown-select--container {
    display: flex;
    justify-content: center;
  }

  @media (min-width: 576px) {
    &.commercial {
      padding: 75px 0 75px 28px;
    }
  }

  @media (max-width: 575px) {
    overflow: hidden;

    .toggle--switch {
      height: 70px;
      padding: 0px;
    }

    .hide {
      z-index: -1;
    }
  }
`;

export { Container };
